import React, { useState, useCallback, useMemo } from "react";
import { Card, Table, Button, Modal } from 'antd';
import { useDispatch } from 'react-redux';
import {Link} from 'react-router-dom';
import NewWebsiteForm from "../forms/newWebsiteForm";
import { deleteWebsite } from "../../stateManagement/actions/data";

const WebsitesList = ({list, publishersList, reloadData}) => {

    const dispatch = useDispatch();

    // Consolidated modal state management
    const [modalState, setModalState] = useState({
        newWebsite: { visible: false },
        deleteWebsite: { visible: false, id: null }
    });

    // Memoized modal handlers to prevent unnecessary recreations
    const showNewWebsiteModal = useCallback(() => {
        setModalState(prev => ({
            ...prev, 
            newWebsite: { visible: true }
        }));
    }, []);

    const handleNewWebsiteCancel = useCallback(() => {
        setModalState(prev => ({
            ...prev, 
            newWebsite: { visible: false }
        }));
    }, []);

    const showDeleteWebsiteModal = useCallback((id) => {
        setModalState(prev => ({
            ...prev, 
            deleteWebsite: { visible: true, id }
        }));
    }, []);

    const handleDeleteWebsiteCancel = useCallback(() => {
        setModalState(prev => ({
            ...prev, 
            deleteWebsite: { visible: false, id: null }
        }));
    }, []);

    // Memoized columns to prevent unnecessary recreations
    const websitesColumns = useMemo(() => [
        {
            key: 'domain',
            title: 'Domain',
            dataIndex: 'domain',
            sorter: (a, b) => a.domain.localeCompare(b.domain)
        },
        {
            key: 'parent',
            title: 'Publisher',
            dataIndex: 'parent',
        },
        {
            key: 'action',
            title: 'Actions',
            render: (data) => (<Button onClick={() => showDeleteWebsiteModal(data._id)} type="link" danger>Delete</Button>)
        }
    ], [showDeleteWebsiteModal]);

    // Memoized delete handler
    const handleDelete = useCallback(() => {
        dispatch(deleteWebsite(modalState.deleteWebsite.id));
        reloadData();
        handleDeleteWebsiteCancel();
    }, [
        dispatch, 
        modalState.deleteWebsite.id, 
        reloadData, 
        handleDeleteWebsiteCancel
    ]);

    return(<>
        <Modal 
            title="Add new website" 
            open={modalState.newWebsite.visible}  
            onCancel={handleNewWebsiteCancel}
            footer={null}
        >
            <NewWebsiteForm publishersList={publishersList} reloadData={reloadData}/>
        </Modal>
        <Card title="Websites list:" size="small" extra={<Link onClick={showNewWebsiteModal}>New</Link>}>
            <Table 
                columns={websitesColumns} 
                dataSource={list} 
                rowKey="_id"
                pagination={{
                    showSizeChanger: true,
                    showQuickJumper: true,
                    showTotal: (total) => `Total: ${total}`
                }}
            />
        </Card>
        <Modal 
            title="Confirmation required" 
            open={modalState.deleteWebsite.visible} 
            onCancel={handleDeleteWebsiteCancel}
            onOk={handleDelete}
        >
            <p>Are you sure?</p>
        </Modal>
    </>)
}

export default WebsitesList;